<template>
  <div class="content-wrapper">    
    <div class="container">
      <v-row>
        <v-col>          
            <div id="modalPrint">
                <div class="modal-dialog modal-lg">
                    <div class="modal-content">
                    <div class="modal-header">     
                    <h4 class="modal-title">Print</h4>
                    <p></p></div>
                    <div class="modal-body" id="billdata">
                    <p></p>
                    <div class="row">
                    <div class="col-sm-6"><img src="images/dhl.png" width="200" height="50"></div>
                    <div class="col-sm-6">
                    <div class="text-center"><h2>Shipment Receipt</h2>	                          
                    </div>
                    </div>
                    </div>

                    <div class="row">	
                    <div class="col-sm-12"><hr style="border:1px solid #0f0f0f"></div>	
                    <div class="col-sm-6">
                    <div v-if="guia.id_empresa != null">
                        <h3> Shipment From: </h3>
                        <div id="s1">{{guia.tipoguia == 'importacion' ? guia.empresa_c : empresa.empresa}}</div>
                        <div id="s2">{{empresa.nombre}}</div>
                        <div id="s3">{{empresa.direccion1}}</div>
                        <div id="s4">{{empresa.direccion2}}</div>
                        <div id="s5">{{empresa.direccion3}} {{guia.tipoguia == 'importacion' ? guia.nit_c : ''}}</div>
                        <div id="s6">{{empresa.pais}}</div>
                        <div id="s7">{{empresa.ciudad}} {{empresa.estado}} {{empresa.zip}}</div>
                        <div id="s8">{{empresa.telefono}}</div>
                    </div>
                    <div v-else>
                        <h3> Shipment From: </h3>
                        <div id="s1">{{guia.empresa_e}}</div>
                        <div id="s2">{{guia.contacto_e}}</div>
                        <div id="s3">{{guia.direccion1_e}}</div>
                        <div id="s4">{{guia.direccion2_e}}</div>
                        <div id="s5">{{guia.direccion3_e}}</div>
                        <div id="s6">{{guia.pais_e}}</div>
                        <div id="s7">{{guia.ciudad_e}} {{guia.estado_e}} {{guia.zip_e}}</div>
                        <div id="s8">{{guia.telefono_e}}</div>
                    </div>
                    </div>

                    <div class="col-sm-6">
                    <h3>Shipment To: </h3>
                        <div id="c1">{{guia.empresa_c}}</div>
                        <div id="c2">{{guia.contacto_c}}</div>
                        <div id="c3">{{guia.direccion1_c}}</div>
                        <div id="c4">{{guia.direccion2_c}}</div>
                        <div id="c5">{{guia.direccion3_c}}</div>
                        <div id="c6">{{guia.pais_c}}</div>
                        <div id="c7">{{guia.ciudad_c}} {{guia.estado_c}} {{guia.zip_c}}</div>
                        <div id="c8">{{guia.telefono_c}}</div>

                    </div>
                    <div class="col-sm-12"><hr></div>
                    <div class="col-sm-6">
                    <h3>Shipment Details:</h3>

                    <div><label>Shipment Date : </label><span>{{guia.created_at}}</span></div>
                    <div><label>Waybill Number : </label><span>{{guia.guia_proveedor}}</span></div>
                    <div><label>Service Type : </label><span>{{guia.servicio}}</span></div>
                    <div><label>Packaging Type : </label><span>{{guia.embalaje}}</span></div>
                    <div><label>Number of Pieces : </label><span>{{guia.piezas}}</span></div>
                    <div><label>Total Weight : </label><span>{{guia.peso}}</span></div>
                    <div><label>Dimensional : </label><span>{{guia.volumen}}</span></div>

                    </div>
                    <div class="col-sm-6">
                    <h3>International Information</h3>
                    <div><label>Declared Value : </label><span>{{guia.valor}} {{guia.moneda}}</span></div>
                    <div><label>Duties and Taxes : </label><span>{{guia.pago == 'Si' ? 'Shipper DTP' : 'Receiver DTU'}}</span></div>                                        
                    </div>

                    <div class="col-sm-12">
                    <h3>Billing Information</h3>
                    <div><label>DHL Account : </label><span></span></div>
                    </div>
                    <div class="col-sm-12">
					<h4>Reference Information</h4>
                        <div><label>Reference : </label><span>{{guia.guia_interna}}</span></div>
                    </div>
                    <div class="col-sm-12"><br><br></div>
                    <div class="col-sm-12">
                    <h3>Description of Contents</h3>
                    <div><label>Description : </label><span>{{guia.descripcion}}</span></div>
                    </div>

                    </div>
                    </div>
                    <hr class="border">
                    <div class="modal-footer">    
                        <v-btn color="blue" outlined @click="imprimirGuia()">Imprimir</v-btn><p></p>
                    </div></div>
                    <p></p></div>                        
            </div>
        </v-col>
      </v-row>      
    </div>    
  </div>
</template>
<script>
import apicon from '../plugins/apicon';
import $ from 'jquery';
export default {    
  props: {
      id: {
      type: Number,
      default: null,
    }
  },  
  created: function () {},
  data() {
    return {     
        guia: null,
        empresa: null,
        isCliente: 1,    
    };
  },
  methods: {
      fillDatosGuia:async function(){
      await apicon.getDataApi(apicon.getApiBaseUrl() + 'guias/' + this.id).then((result) => {
        this.guia = result;
      });
    },    
    fillEmpresa:async function(){
      await apicon.getDataApi(apicon.getApiBaseUrl() + 'empresa/' + this.guia.id_empresa).then((result) => {
        this,this.empresa = result;
      });
    },
    imprimirGuia: function(){
      var mywindow = window.open('', 'tracking div', 'height=400,width=600'); 
      mywindow.document.write('<html><head><link rel="stylesheet" href="https://maxcdn.bootstrapcdn.com/bootstrap/3.3.6/css/bootstrap.min.css"><link rel="stylesheet" href="css/print.css" media="print" /><link rel="stylesheet" href="css/bootstrap-print.min.css" media="print"/></head><body onload="window.print()">');                                
      mywindow.document.write($("#billdata").html());
      mywindow.document.write('</body></html>');
      mywindow.document.close(); // necessary for IE >= 10
      mywindow.focus(); // necessary for IE >= 10
      setTimeout(function(){mywindow.close();}, 1000);
    },
  },
  mounted: async function() {
    apicon.setAuthHeaders();    
    await this.fillDatosGuia();    
    await this.fillEmpresa();
    this.isCliente = localStorage.getItem('cliente');
  },
};
</script>
<style scoped src="bootstrap/dist/css/bootstrap.css">

</style>
